<script>

    import './$styles/global.scss'
    import './$styles/light.scss'
    import './$styles/dark.scss'
    
    import Router from 'svelte-spa-router'
    import { toast } from 'bulma-toast'
    import { replace } from 'svelte-spa-router'

    import { routes } from './routes'
    import { configStore, userStore } from './stores'

    import StorageService from './$services/storage.service'
    import ConfigsService from './$services/configs.service'
    import LocalStorage from './$services/storage.service'
    import UsersService from './$services/users.service'

    let dark = LocalStorage.getItem('dark')

    getConfig()
    getUser()

    async function getConfig() {
        try {

            if(!$userStore) return
    
            const resp = await ConfigsService.getConfig()
    
            if(!resp.success)
                return toast({message: resp.error.message, type: 'is-danger'})
    
            if(!resp.data.email)
                resp.data.email = {}
    
            if(!resp.data.tracking)
                resp.data.tracking = {}
    
            configStore.set(resp.data)

        } catch(e) {
            onLogout()
        }
    }

    async function getUser() {
        try {

            if(!$userStore) return
        
            const resp = await UsersService.getUser()
        
            if(!resp.success)
                return toast({message: resp.error.message, type: 'is-danger'})
        
            userStore.set(resp.data)

        } catch(e) {
            onLogout()
        }
    }

    function onLogout() {
        StorageService.deleteItem("user")
        StorageService.deleteItem("access")
        replace("#/")
    }

</script>

<div id="app" class="app-size" class:is-dark={dark}>
    <Router {routes} />
</div>

<style>
    .app-size {
         width: 100vw; 
        height: 100vh;
        overflow: auto;
    }
</style>